// Feed Interactions Hook
// Manages feed item interactions (like, comment, share, view)

import { useState, useCallback } from "react";
import { UseFeedInteractionsReturn } from "../../types/socialFeed";
import { feedInteractionService } from "../../services/SocialFeed/feedInteractionService";

export const useFeedInteractions = (): UseFeedInteractionsReturn => {
  const [isInteracting, setIsInteracting] = useState(false);

  const handleLike = useCallback(async (itemId: string) => {
    setIsInteracting(true);
    try {
      await feedInteractionService.likeItem(itemId);
    } catch (error) {
      console.error("Failed to like item:", error);
    } finally {
      setIsInteracting(false);
    }
  }, []);

  const handleComment = useCallback(async (itemId: string, comment: string) => {
    setIsInteracting(true);
    try {
      await feedInteractionService.commentOnItem(itemId, comment);
    } catch (error) {
      console.error("Failed to comment on item:", error);
    } finally {
      setIsInteracting(false);
    }
  }, []);

  const handleShare = useCallback(async (itemId: string, platform: string) => {
    setIsInteracting(true);
    try {
      await feedInteractionService.shareItem(itemId, platform);
    } catch (error) {
      console.error("Failed to share item:", error);
    } finally {
      setIsInteracting(false);
    }
  }, []);

  const handleView = useCallback(async (itemId: string) => {
    setIsInteracting(true);
    try {
      await feedInteractionService.viewItem(itemId);
    } catch (error) {
      console.error("Failed to record view:", error);
    } finally {
      setIsInteracting(false);
    }
  }, []);

  return {
    handleLike,
    handleComment,
    handleShare,
    handleView,
    isInteracting,
  };
};
